import Vue from "vue";
import { morphDate } from "vue-morphling";
function slug(s) {
    var slug = abString(s);
    //Xóa các ký tự đặt biệt
    slug = slug.replace(/(?!([a-z0-9-]))./g, "-");
    //replace nhiều ký tự - => -
    slug = slug.replace(/-+/g, "-");
    //remove ký tự - ở đầu và cuối
    slug = slug.replace(/^-/g, "");
    slug = slug.replace(/-$/g, "");
    return slug;
}

function abString(s) {
    var slug;
    //Đổi chữ hoa thành chữ thường, cắt khoảng trắng
    slug = s.toLowerCase().trim();
    //Đổi ký tự có dấu thành không dấu
    slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, "a");
    slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, "e");
    slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, "i");
    slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, "o");
    slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, "u");
    slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, "y");
    slug = slug.replace(/đ/gi, "d");
    return slug;
}
Vue.filter("truncate", function(text, length, suffix) {
    if (text.length <= length) return text;
    return text.substring(0, length) + suffix;
});
Vue.filter("slug", slug);
Vue.filter("abString", abString);
Vue.use(morphDate);
